import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session"; // using session storage
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["DashboardReducer","UserReducer", "ContactRedcuer"],
  blacklist: [
    "LettersReportsReducer",
    "modalReducer",    
    "PersonalDetailsReducer",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// eslint-disable-next-line
export default () => {
  let store = createStore(
    persistedReducer,
    compose(applyMiddleware(thunk), composeEnhancers())
  );
  let persistor = persistStore(store);
  return { store, persistor };
};
